import {APP_CONFIG} from "../../config";
import {Utils} from "../../helpers/utils";
import EventBus from "../../bus/events";
import store from '../store';
import APP_API from '../../api/pgsettings.js';

/*
|-------------------------------------------------------------------------------
| VUEX modules/pgsettings.jss
|-------------------------------------------------------------------------------
| The Vuex data store for the pgSettings
*/

import PGSETTINGSAPI from '../../api/pgsettings.js';
import {Loading} from 'element-ui';

export const pg_settings_module = {
    state: {
        pgSettings: [],
        pgSettingsStatus: 0,

        pgSetting: {},
        pgSettingLoadStatus: 0,

        pgSettingCreatedStatus: 0,

        pgSettingDeleteStatus: 0
    },

//https://serversideup.net/build-vuex-module/

    /*
    * * status = 0 -> No loading has begun
    * status = 1 -> Loading has started
    * status = 2 -> Loading completed successfully
    * status = 3 -> Loading completed unsuccessfully
    * status = 4 -> created successfully
    * status = 5 -> updated successfully
    * status = 6 -> taken successfully
    * */
    /*
          Defines the actions used to retrieve the data.
        */
    actions: {
        /*
          Loads the pgSettings from the API
        */
        loadSettings({commit}) {
            commit('setPgSettingsLoadStatus', 1);
            let loadingInstance = Loading.service({fullscreen: true});

            PGSETTINGSAPI.getBriefs()
                .then(function (response) {
                    loadingInstance.close();
                    commit('setPgSettings', response.data);
                    commit('setPgSettingsLoadStatus', 2);
                })
                .catch(error => {
                    loadingInstance.close();
                    console.log(error.response);
                    console.log("Status Response " + error.response.data.message);
                    commit('setPgSetting', {});
                    commit('setPgSettingLoadStatus', 3);
                    // app.showSnackBar(error.response.data.message);
                })
                .catch(function () {
                    loadingInstance.close();
                    commit('setPgSettings', []);
                    commit('setPgSettingsLoadStatus', 3);
                });
        },

        /*
          Loads an individual pgSetting from the API
        */
        loadSetting({commit}, data) {
            commit('setPgSettingLoadStatus', 1);
            let loadingInstance = Loading.service({fullscreen: false});

            PGSETTINGSAPI.getPGSetting(data.project)
                .then(function (response) {
                    loadingInstance.close();
                    console.log("Response " + JSON.stringify(response.data.data.data[0]));
                    commit('setPgSetting', response.data.data.data[0]);
                    commit('setPgSettingLoadStatus', 2);
                })
                .catch(error => {
                    loadingInstance.close();
                    console.log(error.response);
                    console.log("Status Response " + error.response.data.message);
                    commit('setPgSetting', {});
                    commit('setPgSettingLoadStatus', 3);
                    // app.showSnackBar(error.response.data.message);
                }).catch(function (resp) {
                loadingInstance.close();
                console.log('FAILURE!!');
                commit('setPgSetting', {});
                commit('setPgSettingLoadStatus', 3);
            });
        },

        /*
         Loads an individual pgSetting from the API
       */
        createPGSetting({commit}, pgSetting_data) {
            let loadingInstance = Loading.service({fullscreen: false});
            commit('setPgSettingCreatedStatus', 1);
            var data = pgSetting_data.settings;
            console.log("POST data " + JSON.stringify(data) + data.project + " - " + data.public_key);

            PGSETTINGSAPI.postCreatePGSettings(data.project, data.public_key)
                .then(function (response) {
                    loadingInstance.close();
                    console.log("Response " + JSON.stringify(response.data));
                    commit('setPgSettingCreatedStatus', 4);
                }).catch(error => {
                loadingInstance.close();
                console.log(JSON.stringify(error.response));
                console.log("Status Response " + error.response.data.message);
                commit('setPgSettingCreatedStatus', 0);
            }).catch(function (resp) {
                loadingInstance.close();
                console.log('FAILURE!!');
                commit('setPgSettingCreatedStatus', 0);
            });
        },
    },

    /*
      Defines the mutations used
    */
    mutations: {
        /*
          Sets the pgSettings load status
        */
        setPgSettingsLoadStatus(state, status) {
            state.pgSettingsLoadStatus = status;
        },

        /*
          Sets the pgSettings
        */
        setPgSettings(state, pgSettings) {
            state.pgSettings = pgSettings;
        },

        /*
          Set the pgSetting load status
        */
        setPgSettingLoadStatus(state, status) {
            state.pgSettingLoadStatus = status;
        },

        /*
          Set the pgSetting
        */
        setPgSetting(state, pgSetting) {
            state.pgSetting = pgSetting;
        },

        /*
         Set the pgSetting created status
       */
        setPgSettingCreatedStatus(state, status) {
            state.pgSettingCreatedStatus = status;
        },
    },

    /*
      Defines the getters used by the module
    */
    getters: {
        /*
          Returns the pgSettings load status.
        */
        getPgSettingsLoadStatus(state) {
            return state.pgSettingsLoadStatus;
        },

        /*
          Returns the pgSettings.
        */
        getPgSettings(state) {
            return state.pgSettings;
        },

        /*
          Returns the pgSettings load status
        */
        getPgSettingLoadStatus(state) {
            return state.pgSettingLoadStatus;
        },

        /*
          Returns the pgSetting
        */
        getPgSetting(state) {
            return state.pgSetting;
        },

        /*
         Returns the pgSettings load status.
       */
        getPgSettingCreatedStatus(state) {
            return state.pgSettingCreatedStatus;
        },
    }
}
